import './styles/index.scss';
import HamburgerButton from '@/features/Buttons/Hamburger/HamburgerButton';
import ExitButton from '@/features/Buttons/Exit/ExitButton';
import { Timer } from '@/features/Timer/Timer';
import { AddFundsWrapper } from '@/features/Wrappers/AddFundsWrapper';
import CloseGameWindowButton from '@/features/GameWindow/CloseGameWindowButton';
import { GameWindowControlsHeader } from '@/features/GameWindow/GameWindowControlsHeader';
import { Version } from '@/features/Version/Version';
import GameWindowFooter from '../GameWindow/GameWindowFooter';
import { getIconProductType } from '../GenericIcon/types';
import { GenericIcon } from '../GenericIcon/GenericIcon';
import { useStore } from '@/store/useStore';
import { SWJModule } from '../SWJ/TopBarModule';
import { MinMaxGameToggle } from '../SWJ/MinMaxGameToggle/MinMaxGameToggle';
import { useShallow } from 'zustand/react/shallow';
import { useAppOrientation } from '@/lostHooks/orientation/useOrientation';
import { useSwjBarPhase } from './useSwjBarPhase';
import {
  getJackpotModeParam,
  resolveJackpotMode,
} from '@/features/SWJ/helpers/resolveJackpotMode';
import { isExperimentInTreatment } from '@/utilities/getters/getAmplitudeExperiment';
import { useExperimentExposure } from '@/utilities/logger/amplitude/experiments/experimentExposure';
import { LaunchDetachedButton } from '../LoadingScreen/LaunchDetachedButton';

const DefaultControlsOverlay = () => {
  const gameWindowOpen = useStore((s) => s.gameWindowContext.gameWindowOpen);
  const { showGameWindow } = useStore((s) => s.commonUIContext);
  const { gameWindowExpansionState, isSwjFlagEnabled } = useStore(
    useShallow((state) => state.swj),
  );
  const swjToggle = useStore(
    useShallow((state) => state?.swj?.jackpotData?.enabled),
  );
  const isSwjExperimentEnabled = useStore((state) =>
    isExperimentInTreatment(state.amplitudeExperiments, 'site-wide-jackpots'),
  );
  useExperimentExposure('site-wide-jackpots');
  const showSWJElements = resolveJackpotMode({
    jackpotModeParam: getJackpotModeParam(),
    swjEnabled: swjToggle ?? false,
    swjFlagEnabled: isSwjFlagEnabled,
    swjExperimentEnabled: isSwjExperimentEnabled,
    showGameWindow: showGameWindow ?? false,
  });

  const isPortrait = useAppOrientation() === 'portrait';
  const isBarExpanded = Boolean(
    showSWJElements && (isPortrait || gameWindowExpansionState),
  );

  const swjSlotClass = useSwjBarPhase(isBarExpanded, isPortrait);

  return (
    <>
      <div className={`slot exit`}>
        {!gameWindowOpen && <LaunchDetachedButton />}
        <ExitButton />
      </div>
      {!showSWJElements && (
        <div className="slot logo">
          <GenericIcon type="logo" product={getIconProductType()} />
        </div>
      )}
      <div className={`slot timers`}>
        <Timer isSWJ={showSWJElements} />
      </div>
      {showGameWindow && (
        <>
          {showSWJElements && (
            <div className={swjSlotClass}>
              <SWJModule />
            </div>
          )}
          {showSWJElements && !gameWindowOpen && (
            <div className="slot jackpot toggle">
              <MinMaxGameToggle />
            </div>
          )}

          {gameWindowOpen ? (
            <>
              <div className="slot close">
                <div className="close-button">
                  <CloseGameWindowButton />
                </div>
              </div>
              <div className="slot controls">
                <GameWindowControlsHeader />
              </div>

              <GameWindowFooter />
            </>
          ) : (
            <div className={`slot hamburger`}>
              <HamburgerButton />
            </div>
          )}

          <div className={`slot funds`}>
            <AddFundsWrapper />
          </div>
          <Version />
        </>
      )}
    </>
  );
};

export default DefaultControlsOverlay;
